import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiMapPin, FiMessageCircle, FiNavigation, FiPackage } = FiIcons;

const trustItems = [
  [FiMapPin, 'Atención local', 'Una marca creada para servir a Bonao.'],
  [FiMessageCircle, 'Comunicación directa', 'Habla con nosotros fácilmente por WhatsApp.'],
  [FiNavigation, 'Servicio en Bonao', 'Cobertura enfocada en nuestra comunidad.'],
  [FiPackage, 'Entregas y diligencias', 'Buscamos, recogemos, trasladamos y entregamos.']
];

function TrustSection() {
  return (
    <section className="trust section">
      <div className="container trust__layout">
        <div className="section-heading">
          <span className="eyebrow">Confianza cercana</span>
          <h2>Servicio local en el que <em>puedes confiar.</em></h2>
          <p>Trato directo, comunicación clara y disposición para ayudarte a resolver.</p>
        </div>
        <div className="trust__grid">
          {trustItems.map(([icon, title, text]) => (
            <article className="trust-item" key={title}>
              <span><SafeIcon icon={icon} /></span>
              <div><h3>{title}</h3><p>{text}</p></div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default TrustSection;